'use client';

import {usePathname, useRouter} from '@/i18n/navigation';
import clsx from 'clsx';
import {useLocale, useTranslations} from 'next-intl';
import {useParams} from 'next/navigation';
import {ReactNode, useTransition} from 'react';

type Props = {
  children: ReactNode;
  defaultValue: string;
};

export default function LocaleSwitcherBtn({children, defaultValue}: Props) {
  const router = useRouter();
  const [isPending, startTransition] = useTransition();
  const pathname = usePathname();
  const params = useParams();
  const t = useTranslations('LocaleSwitcher');
  const locale = useLocale();

  return (
    <button
      className={clsx(
        'relative cursor-pointer',
        isPending && 'transition-opacity [&:disabled]:opacity-30'
      )}
      onClick={() => {
        startTransition(() => {
          const nextLocale = locale === 'zh' ? 'en' : 'zh';
          const searchQuery = window.location.search;
          if (nextLocale == 'en') {
            router.replace(
              // @ts-expect-error -- TypeScript will validate that only known `params`
              // are used in combination with a given `pathname`. Since the two will
              // always match for the current route, we can skip runtime checks.
              {pathname: `${pathname}${searchQuery}`, params},
              {locale: nextLocale}
            );
            router.refresh();
          } else {
            router.replace(
              // @ts-expect-error -- TypeScript will validate that only known `params`
              // are used in combination with a given `pathname`. Since the two will
              // always match for the current route, we can skip runtime checks.
              {pathname: `${pathname}${searchQuery}`, params},
              {locale: nextLocale}
            );
            router.refresh();
          }
        });
      }}
    >
      <div className="hidden md:flex">
        <div className="relative content-text ">
          <div>
            <div>
              <div className="header-title hover-underline">
                {t('nextLang')}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="md:hidden">
        <div>
          <div className="text-black px-3 py-2 rounded-md flex items-center font-[400] text-[0.875rem]">
            {t('nextLang')}
          </div>
        </div>
      </div>
    </button>
  );
}
